export default __webpack_public_path__ + "static/media/acmLogo.3536057f.png";